/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyBoardController', DinghyBoardController);

    DinghyBoardController.$inject = ['$state', '$scope','$sce', 'DinghyBoard', 'ParseLinks', 'AlertService', 'pagingParams'];

    function DinghyBoardController($state, $scope, $sce, DinghyBoard, ParseLinks, AlertService, pagingParams) {
        var vm = this;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 99;
        vm.loadAll = loadAll;
        vm.dinghies = [];
        vm.dinghies_inactive = [];

        loadAll();

        function loadAll () {
            DinghyBoard.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                active: true
            }, function (result) {
                vm.dinghies = result;
            }, onError);
            DinghyBoard.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: ['dateDeactivated,desc'],
                active: false
            }, function (result) {
                vm.dinghies_inactive = result;
            }, onError);
        }

        function sort() {
            var sorting = vm.reverse ? 'asc' : 'desc';
            var result = [vm.predicate + ',' + sorting];
            if (vm.predicate !== 'type') {
                result.push('type,' + sorting)
            }
            if (vm.predicate !== 'id') {
                result.push('id,' + sorting);
            }
            return result;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: null
            });
        }

        var trusted = {};
        $scope.getPopoverContent = function(content) {
            return trusted[content] || (trusted[content] = $sce.trustAsHtml(content));
        }

    }
})();
